import type { TourDefinition } from '../../types/tour';

export const widgetCustomizationFirstTour: TourDefinition = {
  key: 'widget_customization_first',
  title: 'ウィジェットカスタマイズツアー',
  steps: [
    {
      target: '#widget-toggle-list',
      title: 'ウィジェット ON/OFF',
      content:
        '表示したいウィジェットをトグルで切り替えます。OFF にしたウィジェットはダッシュボードから消えます。',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '#widget-drag-handle',
      title: '並び替え',
      content:
        'ウィジェットの順序を変えるには、ハンドルをドラッグします。レーンをまたいで移動できます。',
      placement: 'left',
    },
    {
      target: '#widget-save-button',
      title: '保存',
      content:
        '変更を保存するとサーバーに同期されます。次回ログイン時にも反映されます。',
      placement: 'top',
    },
  ],
};
